<script lang="ts">
  import { AatmanovaClient } from '@aatmanova/sdk';
  import { API_URL } from './config.js';
  import { QueryClient, QueryClientProvider } from '@tanstack/svelte-query';
  import Dashboard from './Dashboard.svelte';

  // Core API client definition using dynamic configuration
  const client = new AatmanovaClient(API_URL);

  // Query Client initialization
  const queryClient = new QueryClient();
</script>

<QueryClientProvider client={queryClient}>
  <Dashboard {client} />
</QueryClientProvider>
